import { X, AlertTriangle } from 'lucide-react';

interface DuplicateMappingNameModalProps {
  isOpen: boolean;
  onClose: () => void;
}

/**
 * Modal shown when attempting to save a mapping with a duplicate name
 */
const DuplicateMappingNameModal = ({ isOpen, onClose }: DuplicateMappingNameModalProps) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-xl p-6 max-w-2xl w-full mx-4 flex flex-col">
        <div className="flex justify-between items-center mb-4">
          <div className="flex items-center text-red-600">
            <AlertTriangle className="h-6 w-6 mr-2" />
            <h2 className="text-xl font-bold text-slate-900">Duplicate Mapping Name</h2>
          </div>
          <button
            onClick={onClose}
            className="text-slate-400 hover:text-slate-600 transition-colors"
          >
            <X className="h-6 w-6" />
          </button>
        </div>
        <div className="mb-6 space-y-2">
          <p className="text-slate-700">
            A field mapping with this name already exists. Each mapping must have a unique name.
          </p>
          <p className="text-slate-500 text-sm">
            Please choose a different name and try saving again.
          </p>
        </div>
        <div className="mt-auto flex justify-end pt-4 border-t border-slate-200">
          <button
            onClick={onClose}
            className="px-4 py-2 border border-slate-300 rounded-md text-slate-700 hover:bg-slate-50 transition-colors"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default DuplicateMappingNameModal;
